/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard Service
 * This is the API documentation of the Dashboard service
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ProgressRepresentation } from './ProgressRepresentation';
import {
    ProgressRepresentationFromJSON,
    ProgressRepresentationFromJSONTyped,
    ProgressRepresentationToJSON,
    ProgressRepresentationToJSONTyped,
} from './ProgressRepresentation';
import type { ErrorRepresentation } from './ErrorRepresentation';
import {
    ErrorRepresentationFromJSON,
    ErrorRepresentationFromJSONTyped,
    ErrorRepresentationToJSON,
    ErrorRepresentationToJSONTyped,
} from './ErrorRepresentation';
import type { TicketStatus } from './TicketStatus';
import {
    TicketStatusFromJSON,
    TicketStatusFromJSONTyped,
    TicketStatusToJSON,
    TicketStatusToJSONTyped,
} from './TicketStatus';
import type { ResultRepresentation } from './ResultRepresentation';
import {
    ResultRepresentationFromJSON,
    ResultRepresentationFromJSONTyped,
    ResultRepresentationToJSON,
    ResultRepresentationToJSONTyped,
} from './ResultRepresentation';

/**
 * 
 * @export
 * @interface TicketRepresentation
 */
export interface TicketRepresentation {
    /**
     * 
     * @type {string}
     * @memberof TicketRepresentation
     */
    ticketId?: string;
    /**
     * 
     * @type {TicketStatus}
     * @memberof TicketRepresentation
     */
    status?: TicketStatus;
    /**
     * 
     * @type {Date}
     * @memberof TicketRepresentation
     */
    createdAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof TicketRepresentation
     */
    startedAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof TicketRepresentation
     */
    finishedAt?: Date;
    /**
     * 
     * @type {ProgressRepresentation}
     * @memberof TicketRepresentation
     */
    progress?: ProgressRepresentation;
    /**
     * 
     * @type {ResultRepresentation}
     * @memberof TicketRepresentation
     */
    result?: ResultRepresentation;
    /**
     * 
     * @type {ErrorRepresentation}
     * @memberof TicketRepresentation
     */
    error?: ErrorRepresentation;
}



/**
 * Check if a given object implements the TicketRepresentation interface.
 */
export function instanceOfTicketRepresentation(value: object): value is TicketRepresentation {
    return true;
}

export function TicketRepresentationFromJSON(json: any): TicketRepresentation {
    return TicketRepresentationFromJSONTyped(json, false);
}

export function TicketRepresentationFromJSONTyped(json: any, ignoreDiscriminator: boolean): TicketRepresentation {
    if (json == null) {
        return json;
    }
    return {
        
        'ticketId': json['ticketId'] == null ? undefined : json['ticketId'],
        'status': json['status'] == null ? undefined : TicketStatusFromJSON(json['status']),
        'createdAt': json['createdAt'] == null ? undefined : (new Date(json['createdAt'])),
        'startedAt': json['startedAt'] == null ? undefined : (new Date(json['startedAt'])),
        'finishedAt': json['finishedAt'] == null ? undefined : (new Date(json['finishedAt'])),
        'progress': json['progress'] == null ? undefined : ProgressRepresentationFromJSON(json['progress']),
        'result': json['result'] == null ? undefined : ResultRepresentationFromJSON(json['result']),
        'error': json['error'] == null ? undefined : ErrorRepresentationFromJSON(json['error']),
    };
}

export function TicketRepresentationToJSON(json: any): TicketRepresentation {
    return TicketRepresentationToJSONTyped(json, false);
}

export function TicketRepresentationToJSONTyped(value?: TicketRepresentation | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'ticketId': value['ticketId'],
        'status': TicketStatusToJSON(value['status']),
        'createdAt': value['createdAt'] == null ? value['createdAt'] : value['createdAt'].toISOString(),
        'startedAt': value['startedAt'] == null ? value['startedAt'] : value['startedAt'].toISOString(),
        'finishedAt': value['finishedAt'] == null ? value['finishedAt'] : value['finishedAt'].toISOString(),
        'progress': ProgressRepresentationToJSON(value['progress']),
        'result': ResultRepresentationToJSON(value['result']),
        'error': ErrorRepresentationToJSON(value['error']),
    };
}

